const ROOT = '/'
const ADMIN_BASE = '/admin/dashboard'
const CLIENT_PORTAL_BASE = '/client/portal'
const SETTINGS_BASE = '/app/settings'

import { SETTING_PAGES, SETTING_TOPICS } from '@/constants/settings/topics'

const INTEGRATIONS_BASE = '/integrations'
const APP_BASE = '/app'

const ADMIN = {
  ROOT: '',
  DASHBOARD: `${ADMIN_BASE}/dashboard`,
  CUSTOMERS: {
    CUSTOMER_LIST: `${ADMIN_BASE}/customers`,
    CUSTOMER_DETAIL: `${ADMIN_BASE}/customers/:uuid`,
    CUSTOMER_MAP: `${ADMIN_BASE}/customers/map`
  },
  VOICE: {
    PHONE_NUMBER_LIST: `${ADMIN_BASE}/voice/phone-numbers`,
    PHONE_NUMBER_DETAIL: `${ADMIN_BASE}/voice/phone-numbers/:uuid`,
    PHONE_NUMBER_CREATE: `${ADMIN_BASE}/voice/phone-numbers/create`,
    CALL_LIST: `${ADMIN_BASE}/voice/calls`,
    CALL_DETAIL: `${ADMIN_BASE}/voice/calls/:uuid`
  },
  EMAIL: {
    INBOUND_EMAIL_LIST: `${ADMIN_BASE}/inbound-emails`,
    INBOUND_EMAIL_DETAIL: `${ADMIN_BASE}/inbound-emails/:uuid`
  },
  DOCUMENTS: {
    DOCUMENTS_LIST: `${ADMIN_BASE}/documents/documents`,
    DOCUMENT_CREATE: `${ADMIN_BASE}/documents/documents/create`,
    DOCUMENT_DETAIL: `${ADMIN_BASE}/documents/documents/:uuid`
  },
  PAYMENTS: {
    INVOICES_LIST: `${ADMIN_BASE}/payments/invoices`,
    INVOICES_EXPORT: `${ADMIN_BASE}/payments/invoices/export`
  },
  QUESTIONNAIRES: {
    QUESTIONNAIRE_LIST: `${ADMIN_BASE}/questionnaires`,
    QUESTIONNAIRE_DETAIL: `${ADMIN_BASE}/questionnaires/:uuid`
  },
  USERS: {
    USER_LIST: `${ADMIN_BASE}/users`,
    USER_DETAIL: `${ADMIN_BASE}/users/:uuid`
  },
  FEEDBACK: {
    FEEDBACK_LIST: `${ADMIN_BASE}/feedback`,
    FEEDBACK_DETAIL: `${ADMIN_BASE}/feedback/:uuid`
  },
  CHATS: {
    CHAT_LIST: `${ADMIN_BASE}/chats`,
    CHAT_DETAIL: `${ADMIN_BASE}/chats/:uuid`
  },
  WORD_TEMPLATES: {
    REVIEW: `${ADMIN_BASE}/word-templates/review`,
    REVIEW_DETAIL: `${ADMIN_BASE}/word-templates/review/:uuid`
  }
}

const APP = {
  ROOT: '',
  EXPORT: `${APP_BASE}/${INTEGRATIONS_BASE}/:integration_name/export/:uuid`,
  CASES: {
    CASE_CREATE: `${APP_BASE}/cases/create`,
    CASE_DETAIL: {
      ROOT: `${APP_BASE}/cases/:uuid`,
      OVERVIEW: `${APP_BASE}/cases/:uuid`,
      COMMUNICATION: `${APP_BASE}/cases/:uuid/communication`,
      ENTITIES: `${APP_BASE}/cases/:uuid/entities/:entityUuid?`,
      DOCUMENTS: `${APP_BASE}/cases/:uuid/documents`,
      APPOINTMENTS: `${APP_BASE}/cases/:uuid/appointments`,
      LAW_SPECIFIC_DATA: `${APP_BASE}/cases/:uuid/law-specific-data`,
      DOCUMENT_GENERATION: `${APP_BASE}/cases/:uuid/document-generation`,
      TIMELINE: `${APP_BASE}/cases/:uuid/timeline`,
      AI_CHAT: `${APP_BASE}/cases/:uuid/chat`
    }
  },
  SETTINGS: {
    ROOT: SETTINGS_BASE,
    EMAILS: {
      JUPUS_EMAIL: `${SETTINGS_BASE}/${SETTING_TOPICS.EMAILS}/${SETTING_PAGES.EMAILS.JUPUS_EMAIL}`,
      TEMPLATES: `${SETTINGS_BASE}/${SETTING_TOPICS.EMAILS}/${SETTING_PAGES.EMAILS.TEMPLATES}`,
      TEMPLATE_DETAIL: `${SETTINGS_BASE}/${SETTING_TOPICS.EMAILS}/${SETTING_PAGES.EMAILS.TEMPLATES}/:uuid`,
      DESIGN: `${SETTINGS_BASE}/${SETTING_TOPICS.EMAILS}/${SETTING_PAGES.EMAILS.DESIGN}`,
      SIGNATURES: `${SETTINGS_BASE}/${SETTING_TOPICS.EMAILS}/${SETTING_PAGES.EMAILS.SIGNATURES}`,
      NOTIFICATIONS: `${SETTINGS_BASE}/${SETTING_TOPICS.EMAILS}/${SETTING_PAGES.EMAILS.NOTIFICATIONS}`,
      PLACEHOLDERS: `${SETTINGS_BASE}/${SETTING_TOPICS.EMAILS}/${SETTING_PAGES.EMAILS.PLACEHOLDERS}`
    },
    APPOINTMENTS: {
      SETUP: `${SETTINGS_BASE}/${SETTING_TOPICS.APPOINTMENTS}/${SETTING_PAGES.APPOINTMENTS.SETUP}`,
      CALENDAR_LIST: `${SETTINGS_BASE}/${SETTING_TOPICS.APPOINTMENTS}/${SETTING_PAGES.APPOINTMENTS.CALENDAR_LIST}`,
      CALENDAR_DETAIL: `${SETTINGS_BASE}/${SETTING_TOPICS.APPOINTMENTS}/${SETTING_PAGES.APPOINTMENTS.CALENDAR_DETAIL}/:uuid`,
      SERVICE_LIST: `${SETTINGS_BASE}/${SETTING_TOPICS.APPOINTMENTS}/${SETTING_PAGES.APPOINTMENTS.SERVICE_LIST}`,
      SERVICE_DETAIL: `${SETTINGS_BASE}/${SETTING_TOPICS.APPOINTMENTS}/${SETTING_PAGES.APPOINTMENTS.SERVICE_DETAIL}/:uuid`,
      BASE_SETTINGS: `${SETTINGS_BASE}/${SETTING_TOPICS.APPOINTMENTS}/${SETTING_PAGES.APPOINTMENTS.BASE_SETTINGS}`,
      LINKS: `${SETTINGS_BASE}/${SETTING_TOPICS.APPOINTMENTS}/${SETTING_PAGES.APPOINTMENTS.LINKS}`,
      EMBED: `${SETTINGS_BASE}/${SETTING_TOPICS.APPOINTMENTS}/${SETTING_PAGES.APPOINTMENTS.EMBED}`
    },
    AI: {
      DOCUMENT_GENERATION_TEMPLATE_DETAIL: `${SETTINGS_BASE}/${SETTING_TOPICS.AI}/${SETTING_PAGES.AI.DOCUMENT_GENERATION_TEMPLATES}/:uuid`,
      DOCUMENT_GENERATION_TEMPLATES: `${SETTINGS_BASE}/${SETTING_TOPICS.AI}/${SETTING_PAGES.AI.DOCUMENT_GENERATION_TEMPLATES}`,
      PROMPT_TEMPLATE_DETAIL: `${SETTINGS_BASE}/${SETTING_TOPICS.AI}/${SETTING_PAGES.AI.PROMPT_TEMPLATES}/:uuid`,
      PROMPT_TEMPLATES: `${SETTINGS_BASE}/${SETTING_TOPICS.AI}/${SETTING_PAGES.AI.PROMPT_TEMPLATES}`,
      BASE_SETTINGS: `${SETTINGS_BASE}/${SETTING_TOPICS.AI}/${SETTING_PAGES.AI.BASE_SETTINGS}`
    },
    LAW_OFFICE_SOFTWARE: {
      ACTAPORT: `${SETTINGS_BASE}/${SETTING_TOPICS.LAW_OFFICE_SOFTWARE}/${SETTING_PAGES.LAW_OFFICE_SOFTWARE.ACTAPORT}`,
      ADVOLUX: `${SETTINGS_BASE}/${SETTING_TOPICS.LAW_OFFICE_SOFTWARE}/${SETTING_PAGES.LAW_OFFICE_SOFTWARE.ADVOLUX}`,
      ADVOWARE: `${SETTINGS_BASE}/${SETTING_TOPICS.LAW_OFFICE_SOFTWARE}/${SETTING_PAGES.LAW_OFFICE_SOFTWARE.ADVOWARE}`,
      ANNOTEXT: `${SETTINGS_BASE}/${SETTING_TOPICS.LAW_OFFICE_SOFTWARE}/${SETTING_PAGES.LAW_OFFICE_SOFTWARE.ANNOTEXT}`,
      JURNODES: `${SETTINGS_BASE}/${SETTING_TOPICS.LAW_OFFICE_SOFTWARE}/${SETTING_PAGES.LAW_OFFICE_SOFTWARE.JURNODES}`,
      KLEOS: `${SETTINGS_BASE}/${SETTING_TOPICS.LAW_OFFICE_SOFTWARE}/${SETTING_PAGES.LAW_OFFICE_SOFTWARE.KLEOS}`,
      LAWFIRM: `${SETTINGS_BASE}/${SETTING_TOPICS.LAW_OFFICE_SOFTWARE}/${SETTING_PAGES.LAW_OFFICE_SOFTWARE.LAWFIRM}`,
      RA_MICRO: `${SETTINGS_BASE}/${SETTING_TOPICS.LAW_OFFICE_SOFTWARE}/${SETTING_PAGES.LAW_OFFICE_SOFTWARE.RA_MICRO}`
    }
  },
  CALLS: {
    ROOT: `${APP_BASE}/calls`,
    CALL_DETAIL: `${APP_BASE}/calls/:uuid`
  }
}

export const ROUTES = {
  ROOT,
  ADMIN,
  APP
}

export const ROUTE_BASES = {
  ADMIN_BASE,
  CLIENT_PORTAL_BASE,
  APP_BASE,
  SETTINGS_BASE,
  INTEGRATIONS_BASE
}
